<div class="simple-input" [ngStyle]="{'min-width.px': width, 'max-width.px': width, 'height.px': height}" >
  <input [attr.type]="inputType" [formControl]="control" (input)="valueChanges($event)">
</div>
